<template>
  <div
    id="loading_screen"
    v-if="!exitLoadingScreen"
    class="bg-red-700 fixed top-0 left-0 w-full h-screen z-50 flex flex-col items-center justify-center"
  >
    <the-loading-screen-spinner class="z-10 w-full mb-8" />
    <the-loading-screen-bar class="z-10" />
    <the-loading-screen-background class="z-0" />

    <the-loading-screen-images-preload :exhibit="exhibitToLoad" />
  </div>
</template>

<script>
import { gsap } from "gsap";
import { mapGetters } from "vuex";
import TheLoadingScreenImagesPreload from "./TheLoadingScreenImagesPreload";
import TheLoadingScreenBar from "./TheLoadingScreenBar";
import TheLoadingScreenSpinner from "./TheLoadingScreenSpinner";
import TheLoadingScreenBackground from "./TheLoadingScreenBackground";

export default {
  name: "TheLoadingScreen",
  components: {
    TheLoadingScreenImagesPreload,
    TheLoadingScreenBar,
    TheLoadingScreenSpinner,
    TheLoadingScreenBackground,
  },
  data() {
    return {
      exitLoadingScreen: false,
      exhibitToLoad: "",
    };
  },
  computed: {
    ...mapGetters({ isLoading: "loader/isLoading" }),
  },
  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.runExitAnimation();
      }
    },
  },
  mounted() {
    this.exhibitToLoad = this.$route.path.substring(1);
    this.isLoading ? this.runIntroAnimation() : this.runExitAnimation();
  },
  methods: {
    runIntroAnimation() {},
    runExitAnimation(debug = false) {
      if (debug) return;

      const here = this;
      gsap.to("#loading_screen", {
        ease: "power2.out",
        opacity: "0",
        duration: 3,
        delay: 0.2,
        onStart: () => {
          this.$emit("loaded");
        },
        onComplete: () => {
          here.exitLoadingScreen = true;
        },
      });
    },
  },
};
</script>

<style lang="postcss" scoped>
</style>